export default {
  backendUrl: `${process.env.REACT_APP_API_ENDPOINT}/api`,
  backendUrlV2: `${process.env.REACT_APP_API_ENDPOINT}/api/v2`,
};
